import React, {useCallback, useEffect, useState} from 'react';
import ReviewSlider from './ReviewSlider/ReviewSlider';
import {getLandingReviews} from '../../api/landing.api';
import {NotificationError} from '../../services/notifications';
import {t} from '../../services/i18nHandler';

function LandingPageReviewsSection({language}) {
  const [landingReviews, setLandingReviews] = useState([]);

  const fetchLandingReviews = useCallback(async () => {
    await getLandingReviews().then((res) => {
      setLandingReviews(res);
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {

    });
  }, []);

  useEffect(() => {
    void fetchLandingReviews();
  }, []);

  return (
    <div className="section section--feedback review" data-anchor="reviews">
      <div className="section--inner">
        <div className="section--container">
          <div className="review_container">
            <div className="content-wrap_item review-slider">
              {!!landingReviews.length && (
                <ReviewSlider reviews={landingReviews} language={language} />
              )}
            </div>
            <div className="content-wrap_item feedback-head">
              <div className="section--slogan">{t('landingPage.reviews.slogan')}</div>
              <div className="section--title">{t('landingPage.reviews.title')}</div>
              <div className="section--subtitle">
                {t('landingPage.reviews.text')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

LandingPageReviewsSection.propTypes = {};

export default LandingPageReviewsSection;
